import { keyframes, styled } from "@mui/material/styles";
import { EPaymentStatus } from "../page/main/AiToolsPage";

export const CardParent = styled("div")(() => ({
  display: "flex",
  height: "calc(100vh - 148px)",
  alignItems: "center",
}));

export const Card = styled("div")(() => ({
  background: "#ffffff",
  borderRadius: 16,
  boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
  padding: "20px 24px",
  width: "100%",
}));

export const Title = styled("h3")(() => ({
  margin: 0,
  fontSize: 20,
  marginBottom: 16,
}));

export const InfoRow = styled("div")(() => ({
  display: "grid",
  gridTemplateColumns: "140px 1fr",
  padding: "10px 0",
  borderBottom: "1px solid #eee",
  "&:last-child": {
    borderBottom: "none",
  },
}));

export const Label = styled("div")(() => ({
  fontWeight: 600,
  color: "#555",
}));

export const Value = styled("div")(() => ({
  color: "#222",
}));

export const Status = styled("span")<{ paid?: number }>(({ paid }) => ({
  display: "inline-block",
  padding: "6px 12px",
  borderRadius: 999,
  fontSize: 12,
  fontWeight: 600,
  background:
    paid == EPaymentStatus.success ||
    paid == EPaymentStatus.translate_Processing ||
    paid == EPaymentStatus.translate_Completed
      ? "#e6f7ee"
      : "#fff4e5",
  color:
    paid == EPaymentStatus.success ||
    paid == EPaymentStatus.translate_Processing ||
    paid == EPaymentStatus.translate_Completed
      ? "#1a7f4b"
      : "#b25a00",
}));

export const Actions = styled("div")(() => ({
  display: "flex",
  justifyContent: "flex-end",
  marginTop: 16,
}));
